import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './Buttons.module.scss';

interface SendButtonProps {
	onClick: () => void;
	title?: string;
}

export default function SendButton(props: SendButtonProps) {
	const { onClick, title = 'base.sendSelected' } = props;

	const handlePress = () => {
		onClick && onClick();
	};

	return (
		<div className={styles.actionButton} onClick={handlePress}>
			<Text
				className={styles.title}
				tx={title}
				inline={true}
				firstUpper={true}
			/>
			<img
				className={styles.icon}
				src={'/dist/icons/share-solid.svg'}
				alt={'printer icon'}
			/>
		</div>
	);
}
